import { usePersonalAccounts } from '@/api/models/finance/hooks/usePersonalAccounts'
import { SwiperOption } from '@/components/shared/types-selector/TypesSelector.types'

export const useBalancePremiseOptions = (
  selectedTab?: SwiperOption,
  ALL_FILTER?: SwiperOption
): {
  getSelectedPremise: () => SwiperOption | undefined
  areAccountsLoading?: boolean
  premiseOptions?: Array<{ key: string; title: string; marked: boolean }>
} => {
  const { data: personalAccounts, isLoading: areAccountsLoading } =
    usePersonalAccounts()

  const premiseOptions =
    personalAccounts?.map(personalAccount => ({
      key: personalAccount.personalAccountId,
      title: personalAccount.premiseName,
      marked: personalAccount.hasDebt
    })) || []

  const getSelectedPremise = () => {
    if (premiseOptions.length === 1) {
      return premiseOptions[0]
    } else {
      return selectedTab?.key === ALL_FILTER?.key ? undefined : selectedTab
    }
  }

  return { getSelectedPremise, areAccountsLoading, premiseOptions }
}
